import { render, staticRenderFns } from "./companyqualifications.vue?vue&type=template&id=d1da9246&"
import script from "./companyqualifications.vue?vue&type=script&lang=js&"
export * from "./companyqualifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports